import { render, staticRenderFns } from "./CustomLayout.vue?vue&type=template&id=6fec2d17&scoped=true"
import script from "./CustomLayout.vue?vue&type=script&lang=js"
export * from "./CustomLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomLayout.vue?vue&type=style&index=0&id=6fec2d17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec2d17",
  null
  
)

export default component.exports